module.exports = __webpack_public_path__ + "assets/img/check-white.c9f3ecbe.svg";